var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-payroll"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payroll",
    clipPath: "url(#clip-payroll)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(-45.5 -864.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(45.5 866.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M82.549,872H78.516l-.436-2.993c0-.022-.018-.042-.024-.065a.817.817,0,0,0-.593-.616.831.831,0,0,0-.3-.022.124.124,0,0,1-.029,0h0v0l-2.378.34-.644-2a.882.882,0,0,0-.1-.184c-.02-.031-.031-.069-.053-.1a.816.816,0,0,0-.18-.144.763.763,0,0,0-.069-.055,1.159,1.159,0,0,0-.149-.044,1.037,1.037,0,0,0-.16-.047.728.728,0,0,0-.1.011.736.736,0,0,0-.229.022l-.009,0h0L56.3,871.284l-5,.716H48.451a3.042,3.042,0,0,0-2.951,3.12v23.547a3.042,3.042,0,0,0,2.951,3.12h34.1a3.042,3.042,0,0,0,2.951-3.12V875.12A3.042,3.042,0,0,0,82.549,872Zm-6-1.929.28,1.929H63.073Zm-3.771-2.129.3.94-6.253.9ZM83,898.667c0,.329-.209.62-.451.62h-34.1c-.242,0-.451-.291-.451-.62V875.12a.569.569,0,0,1,.451-.62h34.1a.569.569,0,0,1,.451.62Z",
    transform: "translate(-45.5 -866.073)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.667,
    cy: 1.698,
    rx: 1.667,
    ry: 1.698,
    transform: "translate(29.829 19.123)",
    fill: "#5c6d7e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.0b2895951ce84b0d67f34dbb1be3f979.svg";
export { ForwardRef as ReactComponent };